var _style, _line, _line2, _line3, _line4, _line5, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicalManualControlWithLever({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.2,
    y1: 7.1,
    x2: 4.6,
    y2: 7.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.8,
    y1: 7.1,
    x2: 8.2,
    y2: 7.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.6,
    y1: 7.1,
    x2: 12,
    y2: 7.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.2,
    y1: 7.1,
    x2: 15.6,
    y2: 7.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.6,
    y1: 4.2,
    x2: 3.4,
    y2: 10.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 3.8,
    cy: 10.8,
    rx: 0.8,
    ry: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalManualControlWithLever);
export default __webpack_public_path__ + "static/media/MechanicalManualControlWithLever.cc56c6be7ed48ac861ad237d60be51b3.svg";
export { ForwardRef as ReactComponent };